import { render, staticRenderFns } from "./ModalEditarResponseBodyRequisicao.vue?vue&type=template&id=3978299c&scoped=true"
import script from "./ModalEditarResponseBodyRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarResponseBodyRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarResponseBodyRequisicao.vue?vue&type=style&index=0&id=3978299c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978299c",
  null
  
)

export default component.exports